module.exports = __webpack_public_path__ + "static/img/home4.560c7f61.png";